import { TabPanel, TabPanels } from '@chakra-ui/react';
import React from 'react';
import OfficerAssessmentNotesWrapper from './OfficerAssessmentNotesWrapper';
import EditOfficerAssementWrapper from './EditOfficerAssessmentWrapper';
import { getGetInspectionRemoteSubmissionLocationsQueryKey, useGetOneOfficerAssessmentSuspense, } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { queryClient } from '../../../services/api/query/queryClient';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const OfficerAssessmentModalTabPanels = ({ officerAssessmentId, canEdit, }) => {
    const { inspection } = useInspectionDetailContext();
    const { data: response, refetch } = useGetOneOfficerAssessmentSuspense(officerAssessmentId);
    const officerAssessment = unwrapModel(response);
    if (!officerAssessment) {
        return null;
    }
    const onMutated = async (shouldRefetch = true) => {
        if (shouldRefetch)
            refetch();
        await queryClient.invalidateQueries({
            queryKey: getGetInspectionRemoteSubmissionLocationsQueryKey(inspection.id),
        });
    };
    return (React.createElement(TabPanels, { "data-testid": "officer_assessment_model_tab_panels" },
        React.createElement(TabPanel, null,
            React.createElement(EditOfficerAssementWrapper, { onMutated: onMutated, officerAssessment: officerAssessment, canEdit: canEdit })),
        React.createElement(TabPanel, null,
            React.createElement(OfficerAssessmentNotesWrapper, { onMutated: () => onMutated(false), model: officerAssessment, canEdit: canEdit }))));
};
export default OfficerAssessmentModalTabPanels;
